import jwtDecode from 'jwt-decode';
import _ from 'lodash';

// import { datadogRum } from '@datadog/browser-rum';

export default {
  namespaced: true,
  state: {
    activeMember: undefined,
    openMemberBoardDrawer: true,
    activeMemberRegos: [],
    _id: undefined,
    authenticated: false,
    profile: {
      password: {}
    },
    selectedMember: undefined,
    tokens: {}, // {access_token, refresh_token, id_token, expires_in}
  },
  mutations: {
    login(state, tokens) {
      const profile = jwtDecode(tokens.id_token);
      state.profile = { ...state.profile, ...profile };
      state.tokens = tokens;
      state.authenticated = true;
    },
    updateSelectMember(state, payload) {
      state.selectedMember = payload;
      state.activeMember = payload;
    },
    complete(state, payload) {
      state.profile.dob = payload.dob;
      state.profile.mobile = payload.mobile;
      state.profile.gender = payload.gender;
      if (state.profile.password) state.profile.password.temporary = false;
    },
    logout(state) {
      state.authenticated = false;
      state.profile = {};
      state.tokens = {};
      state.activeMember = {};
      state.selectedMember = {};
    },
    verified(state) {
      state.profile.verified = true;
    },
    setActiveMember(state, member) {
      state.selectedMember = member;
      state.activeMember = member;
    },
    setMemberRegos(state, regos) {
      state.activeMemberRegos = regos;
    },
    setOpenMemberBoardDrawer(state, open) {
      state.openMemberBoardDrawer = open;
    }
  },
  actions: {
  },
  getters: {
    isMemberBoardDrawerOpened(state) {
      return state.openMemberBoardDrawer;
    },
    userId(state) {
      return state.profile._id;
    },
    profile(state) {
      return state.profile;
    },
    roles(state) {
      return state.profile.roles;
    },
    activeMember(state) {
      return state.activeMember;
    },
    getActiveMemberRegos(state) {
      return state.activeMemberRegos;
    },
    selectedMember(state) {
      return state.selectedMember;
    },
    userName(state) {
      return `${state.profile.firstName} ${state.profile.lastName}`;
    },
    userNameAbbr(state) {
      return `${(_.get(state, 'profile.firstName', '')).charAt(0)}${(_.get(state, 'profile.lastName', '')).charAt(0)}`;
    },
    accessToken(state) {
      return state.tokens.access_token;
    },
    refreshToken(state) {
      return state.tokens.refresh_token;
    },
    getUserProfile(state) {
      return state.profile;
    },
    expiry(state) {
      return state.tokens.expires_in;
    },
    isAuthenticated(state) {
      return state.authenticated;
    },
    isTempPassword(state) {
      return _.get(state, 'profile.password.temporary', false);
    },
    isVerified(state) {
      return state.profile.verified;
    },
    uploadHeaders(state) {
      const { profile, tokens } = state;
      const authheader = `${profile._id}:${tokens.access_token}`;
      const encodedString = btoa(authheader);
      const Authorization = `Bearer ${encodedString}`;
      return { Authorization, 'national-id': process.env.VUE_APP_NATIONAL_ID };
    },
  },
};
